import { SVGFC } from '@repo/toolkit/types'

const CalendarFourIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.1635 6.69655C19.1635 5.57906 18.5935 4.58905 17.731 4.01154C17.2135 3.65906 16.591 3.45654 15.9235 3.45654H15.121V5.42905C15.121 5.84154 14.791 6.17905 14.371 6.17905C13.9585 6.17905 13.621 5.84154 13.621 5.42905V3.45654H7.04349V5.42905C7.04349 5.84154 6.70598 6.17905 6.29349 6.17905C5.87349 6.17905 5.54349 5.84154 5.54349 5.42905V3.45654H4.74098C3.84848 3.45654 3.03847 3.81657 2.45349 4.40906C1.86096 4.99403 1.50098 5.80405 1.50098 6.69655V7.19157H19.1635V6.69655Z"
        fill={color}
      />
      <path
        d="M4.74098 19.9034H11.4835C10.9135 18.9209 10.5835 17.7734 10.5835 16.5509C10.5835 12.8459 13.591 9.83839 17.2885 9.83839C17.941 9.83839 18.571 9.92839 19.1635 10.1009V8.69092H1.50098V16.6709C1.50098 18.4559 2.95598 19.9034 4.74098 19.9034Z"
        fill={color}
      />
      <path
        d="M7.04346 2.99219C7.04346 2.5797 6.70595 2.24219 6.29346 2.24219C5.87346 2.24219 5.54346 2.5797 5.54346 2.99219V3.45718H7.04346V2.99219Z"
        fill={color}
      />
      <path
        d="M15.1201 2.99219C15.1201 2.5797 14.7901 2.24219 14.3701 2.24219C13.9576 2.24219 13.6201 2.5797 13.6201 2.99219V3.45718H15.1201V2.99219Z"
        fill={color}
      />
      <path
        d="M17.2885 11.3394C14.416 11.3394 12.0835 13.6794 12.0835 16.5519C12.0835 19.4244 14.416 21.7569 17.2885 21.7569C20.161 21.7569 22.501 19.4244 22.501 16.5519C22.501 13.6794 20.161 11.3394 17.2885 11.3394ZM18.766 17.3019H17.2885C16.876 17.3019 16.5385 16.9644 16.5385 16.5519V15.0069C16.5385 14.5944 16.876 14.2569 17.2885 14.2569C17.7085 14.2569 18.0385 14.5944 18.0385 15.0069V15.8019H18.766C19.1785 15.8019 19.516 16.1319 19.516 16.5519C19.516 16.9644 19.1785 17.3019 18.766 17.3019Z"
        fill={color}
      />
    </svg>
  )
}

export default CalendarFourIcon
